module.exports = __webpack_public_path__ + "static/media/discarded.0954a843.svg";